import React from "react";
import {Legend, Pie, PieChart} from "recharts";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import {grey} from "@material-ui/core/colors";
import {useTheme} from "@material-ui/core";

const useStyles = makeStyles({
    overviewSubscriptionsCount: {
        'text-align': 'center'
    },
    legend: {
        'text-align': 'left'
    },
    legendElement: {
        'display': 'block',
        'margin-right': '10px'
    },
    legendColor: {
        'display': 'inline-block',
        'vertical-align': 'middle',
        'margin-right': '6px',
        'height': '10px',
        'width': '14px',
    }
});

export const SubscriptionsCountPieChart = (props: any) => {
    const classes = useStyles();
    const {subscriptionCount, openCollapsable} = props;
    const {t} = useTranslation();
    const theme = useTheme();

    const subscriptionsData = [
        {
            "name": `${t("_Common.Labels.Used")} ${subscriptionCount.used}`,
            "value": subscriptionCount.used,
            "fill": theme.palette.primary.main
        },
        {
            "name": `${t("_Common.Labels.Available")} ${subscriptionCount.available}`,
            "value": subscriptionCount.available,
            "fill": theme.palette.primary.light
        }
    ];

    return (
        <div className={classes.overviewSubscriptionsCount}>
            <Typography variant='body2'>
                {t(`Subscription.Overview.${subscriptionCount.type}`).toUpperCase()}
            </Typography>
            <Collapse in={openCollapsable}>
                <PieChart width={200} height={200}>
                    <Pie
                        data={subscriptionsData}
                        dataKey="value"
                        nameKey="name"
                        innerRadius={50}
                        outerRadius={60}
                        stroke="none"
                    />
                    <Legend layout="vertical" verticalAlign="bottom"/>
                    <text x={100} y={90} textAnchor='middle' fill={grey[900]} fontSize='225%'>
                        {subscriptionCount.total}
                    </text>
                </PieChart>
            </Collapse>
            {!openCollapsable &&
            <ul className={classes.legend}>
                {
                    subscriptionsData.map(s =>
                        <li key={s.name} className={classes.legendElement}>
                            <div className={classes.legendColor} style={{backgroundColor: s.fill}}/>
                            <span>{s.name}</span>
                        </li>
                    )}
            </ul>
            }
        </div>
    );
};
